module.exports = __webpack_public_path__ + "img/Unidad14-3.2d383af0.png";